<template>
  <div class="car-brands">
    <div class="car-brands__purpose">
      <!-- 标题区域 -->
      <div class="car-brands__title">
        <div class="car-brands__heading">Browse by Brands</div>
        <div class="car-brands__view" @click="gotoAll()">
          <div class="car-brands__view-all">View All</div>
          <img src="@/assets/view-all.svg" class="car-brands__icon" alt="view all">
        </div>
      </div>

      <!-- 品牌卡片区域：PC端每行4个，移动端每行2个 -->
      <div class="car-brands__cards"
        :class="{'car-brands__cards--mobile': deviceType === 'mobile'}">
        <div v-for="(brand, index) in carBrands" :key="`brand-${index}`" class="car-brands__card"
          @click="gotoBrand(brand.value)">
          <img :src="brand.logo" class="car-brands__card-logo" :alt="`${brand.name} logo`">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CarBrands',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType'
    })
  },
  data () {
    return {
      carBrands: [
        {
          name: 'Toyota',
          value: 'Toyota',
          logo: require('@/assets/brands/toyota.png')
        },
        {
          name: 'Volkswagen',
          value: 'Volkswagen',
          logo: require('@/assets/brands/volkswagen.png')
        },
        {
          name: 'Hyundai',
          value: 'Hyundai',
          logo: require('@/assets/brands/hyundai.png')
        },
        {
          name: 'Audi',
          value: 'Audi',
          logo: require('@/assets/brands/audi.png')
        },
        {
          name: 'Nissan',
          value: 'Nissan',
          logo: require('@/assets/brands/nissan.png')
        },
        {
          name: 'Chevrolet',
          value: 'Chevrolet',
          logo: require('@/assets/brands/chevrolet.png')
        },
        {
          name: 'Ford',
          value: 'Ford',
          logo: require('@/assets/brands/ford.png')
        },
        {
          name: 'Honda',
          value: 'Honda',
          logo: require('@/assets/brands/honda.png')
        },
        // {
        //   name: 'BMW',
        //   value: 'BMW',
        //   logo: require('@/assets/brands/bmw.png')
        // },
        // {
        //   name: 'Mercedes-Benz',
        //   value: 'Mercedes-Benz',
        //   logo: require('@/assets/brands/mercedes.png')
        // },
      ]
    }
  },
  methods: {
    // 跳转到全部车辆页面
    gotoAll () {
      // 获取当前路由的channel参数
      const currentChannel = this.$router.currentRoute.params.channel;

      // 如果存在channel参数，则构建带channel的路径
      if (currentChannel) {
        // 构建完整URL
        const baseUrl = window.location.origin;
        // 直接获取当前URL的查询字符串，包括?前缀
        const fullQueryString = window.location.search;
        const fullPath = `${baseUrl}/${currentChannel}/car-list${fullQueryString}`;

        // 使用location跳转
        window.location.href = fullPath;
      } else {
        // 没有channel参数，使用常规router跳转
        this.$router.push({
          path: '/car-list'
        });
      }
    },

    // 根据品牌筛选跳转
    gotoBrand (brand) {
      if (!brand) {
        console.warn('[CarBrands] Missing brand value');
        return;
      }

      // 获取当前路由的channel参数
      const currentChannel = this.$router.currentRoute.params.channel;

      // 如果存在channel参数，则构建带channel的路径
      if (currentChannel) {
        // 获取当前URL的所有查询参数
        const currentParams = new URLSearchParams(window.location.search);
        // 添加或更新brand参数
        currentParams.set('brand', brand);
        // 转换为查询字符串
        const fullQueryString = currentParams.toString() ? `?${currentParams.toString()}` : '';

        // 构建完整URL
        const baseUrl = window.location.origin;
        const fullPath = `${baseUrl}/${currentChannel}/car-list${fullQueryString}`;

        // 使用location跳转
        window.location.href = fullPath;
      } else {
        // 获取当前URL的所有查询参数
        const currentParams = new URLSearchParams(window.location.search);
        // 添加或更新brand参数
        currentParams.set('brand', brand);

        // 转换为对象形式，用于router.push
        const query = {};
        currentParams.forEach((value, key) => {
          query[key] = value;
        });

        // 没有channel参数，使用常规router跳转
        this.$router.push({
          path: '/car-list',
          query: query
        });
      }
    }
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

.car-brands {
	padding: rem(60) 0;
	background: #ffffff;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	align-self: stretch;
	position: relative;

	&__purpose {
		padding: 0 rem(120);
		display: flex;
		flex-direction: column;
		gap: rem(20);
		align-items: flex-start;
		justify-content: flex-start;
		width: 100%;
		box-sizing: border-box;
	}

	&__title {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-self: stretch;
		position: relative;
	}

	&__heading {
		color: #141414;
		text-align: left;
		font-size: rem(24);
		line-height: rem(24);
		font-weight: 700;
		position: relative;
	}

	&__view {
		display: flex;
		align-items: center;
		gap: rem(12);
		cursor: pointer;
	}

	&__view-all {
		font-size: rem(14);
		line-height: rem(14);
		font-weight: 600;
		color: var(--theme-color);
	}

	&__icon {
		flex-shrink: 0;
		width: rem(16);
		height: rem(16);
		position: relative;
		overflow: visible;
	}

	&__cards {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		gap: rem(20);
		align-items: flex-start;
		justify-content: space-between;
		width: 100%;
		margin-top: rem(20);

		// 移动端样式 - 两个一行
		&--mobile {
			gap: rem(16);

			.car-brands__card {
				flex: 0 0 calc(50% - rem(8));
				width: calc(50% - rem(8));
				height: rem(120);
			}
		}
	}

	&__card {
		background: #ffffff;
		border-radius: rem(24);
		border: 1px solid #e9e9e9;
		padding: rem(20);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		flex: 0 0 calc(25% - rem(15));
		width: calc(25% - rem(15));
		height: rem(120);
		box-sizing: border-box;
		transition: transform 0.3s ease;
		cursor: pointer;

		&:hover {
			transform: translateY(-4px);
			box-shadow: 0 rem(8) rem(16) rgba(0, 0, 0, 0.1);
		}
	}

	&__card-logo {
		max-width: 100%;
		max-height: 100%;
		width: auto;
		height: auto;
		object-fit: contain;
	}
}

// 响应式样式 - PC设备
.detect_deviece_pc,
.detect_deviece_desktop {
	.car-brands {
		--fontsize-base: #{$vw_fontsize_pc};
		font-size: calc(var(--fontsize-base) / #{$vw_design_pc} * 100vw);
	}
}

// 响应式样式 - 移动设备
.detect_deviece_mobile {
	.car-brands {
		--fontsize-base: #{$vw_fontsize_mobile};
		font-size: calc(var(--fontsize-base) / #{$vw_design_mobile} * 100vw);
		padding: rem(40) 0;

		&__purpose {
			padding: 0 rem(16);
			width: 100%;
		}
	}
}
</style> 